import request from '@/utils/request'


export function fetchInterest(id) {
  return request({
    url: `/interest/${id}`,
    method: 'get'
  })
}
